import { render } from "./JudgeQueueViewer.vue?vue&type=template&id=0ab9e182&ts=true"
import script from "./JudgeQueueViewer.vue?vue&type=script&lang=ts"
export * from "./JudgeQueueViewer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__